/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cognito_identity_pool_id": "ap-northeast-1:6c03dc0c-d528-4329-ae8a-5752448b37c0",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_wSKRk0l2A",
    "aws_user_pools_web_client_id": "q84a25ku8rrmdo747gihhneiu",
    "oauth": {},
    "aws_user_files_s3_bucket": "mosaic-prod-bucket23448-prod",
    "aws_user_files_s3_bucket_region": "ap-northeast-1",
    "aws_appsync_graphqlEndpoint": "https://ippp5djldfdvpozdadjitnldne.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
